import { defineStore } from "pinia";
import { instance } from "../index";
import { CourseStudentRest } from "@/services/rest/courses-student.rest";

import { ELoader, useAdaptLoaderStore } from "./adapt-loader";
import { firstValueFrom, take } from "rxjs";
import { useAdaptCourseStore } from "./adapt-course";
import { useLearningObjectiveStore } from "./learning-objective";
import { RouteMaterials, useAdaptMaterialStore } from "./adapt-material";
import { useAdaptProgressStore } from "./adapt-progress";
import { getItemStorage } from "@/utils/save-storage.util";

export const store = defineStore({
  id: "adapt-chapter",
  state: () => ({
    chapter: {} as any,
    courseRest: new CourseStudentRest(),
  }),
  actions: {
    setChapter(chapter: any) {
      this.chapter = chapter;
    },
    async getCourseById(userId: string, courseId: string) {
      useAdaptLoaderStore.start(ELoader.CHAPTERS);
      const params = {classroomId:localStorage.getItem("classId")??undefined}
      const response = await firstValueFrom(
        this.courseRest.getCourseByIdGraphs(userId, courseId, params).pipe(take(1))
      );
      this.handleChapterResponse(response);
      await this.handleMaterialsResponse(response, userId, courseId);
      useAdaptCourseStore.course = response;
      useAdaptLoaderStore.stop(ELoader.CHAPTERS);
    },
    getCurrentChapter(): any {
      return this.chapter;
    },
    handleChapterResponse(response: any) {
      this.chapter = {
        ...response.chapters,
        name: response.currentChapterName,
        id: response.currentChapter,
      };
    },
    async handleMaterialsResponse(
      response: any,
      userId: string,
      courseId: string
    ) {
      useAdaptMaterialStore.routeMaterial =
        RouteMaterials[response.learningObjectiveStatus];
      await useAdaptMaterialStore.setMaterials(
        courseId,
        userId,
      );
    },
  },
});
export const useAdaptChapterStore = store(instance);
